import { getNextSibling } from "../utils/dom";

export default class MultiFilePicker extends HTMLInputElement {

    fileList = [];

    connectedCallback() {

        this.addEventListener("change", this.handleChange);
        this.fileListElement.addEventListener("click", this.handleListItemClick);

    }

    disconnectedCallback() {

        this.removeEventListener("change", this.handleChange);

    }

    handleChange = e => {

        const newFiles = Array.from(this.files).filter(file => !this.fileList.includes(file));
        console.log(newFiles);

        this.fileList = this.fileList.concat(newFiles);

        const dt = new DataTransfer();

        this.fileList.forEach(file => dt.items.add(file));

        this.files = dt.files;

        this.renderFiles();

    }

    handleListItemClick = e => {

        if (e.target.matches(".form-file-list-remove")) {
            this.removeFile(e.target.dataset.fileName);
        }

    }

    renderFiles() {
        this.fileListElement.innerHTML = Array.from(this.files)
            .map(file =>
                `<li>${file.name} 
                <span class="form-file-size">
                    (${this.formatFileSize(file.size)})
                </span>
                <button class="form-file-list-remove btn-close btn-sm d-inline" aria-label="Ta bort" data-file-name="${file.name}"></button>
            </li>`).join("");
    }

    removeFile(fileName) {

        const newFiles = Array.from(this.files).filter(file => file.name !== fileName);

        this.fileList = newFiles;

        const dt = new DataTransfer();

        this.fileList.forEach(file => dt.items.add(file));

        this.files = dt.files;

        this.renderFiles();

    }

    formatFileSize(fileSize) {
  
        if (fileSize > 1000 * 1024) {
            return Math.ceil(fileSize / (1000 * 1024)) + " mb";
        }
        else if (fileSize > 1024) {
            return Math.ceil(fileSize / 1024) + " kb";
        }

        return fileSize + " b";
        
    }

    get labelElement() {
        return getNextSibling(this, ".form-file-text");
    }

    get fileListElement() {
        return getNextSibling(this.closest(".form-file"), ".form-file-list");
    }

}

customElements.define('multi-file-picker', MultiFilePicker, { extends: 'input' });